import { CycleItem, ItemList, ReportCycle } from "common/interface/interface"

export const LIMIT = 8 // 报告列表默认显示行数
export const TABLE_LIMIT = 10 // 详情表格默认显示行数
// 对应老版
export const ITEM_FROM_QUERY_KEY = "type"
export const CYCLE_FROM_QUERY_KEY = "cycle"

export const CycleList: CycleItem[] = [
	{
		id: 0,
		en_name: "All",
	},
	{
		id: 5,
		en_name: "Daily",
	},
	{
		id: 1,
		en_name: "Weekly",
	},
	{
		id: 2,
		en_name: "Monthly",
	},
	{
		id: 3,
		en_name: "Quarterly",
	},
	{
		id: 4,
		en_name: "Annually",
	},
	{
		id: 6,
		en_name: "Semiannual",
	},
	{
		id: 7,
		en_name: "Irregular",
	},
]

export const addAllCycle = (list: ReportCycle[]) => {
	return [
		{
			cycle: 0,
			name: "All",
		},
		...list,
	]
}

export const addAllItem = (list: ItemList[]) => {
	return [
		{
			id: 0,
			name: "All",
			en_name: "All",
			sort_number: 0,
			create_time: 0,
			admin_emial: "",
			status: 1,
			has_power: 0,
		},
		...list,
	]
}
